import loadable from '@loadable/component';
import * as React from 'react';

import { Loader } from '../../../components/Loader';

export const ComplaintFormContainerLoadable = loadable<{ onClose(): void }>(() => import('./ComplaintFormContainer'), {
  fallback: <Loader />,
});
